/* eslint-disable @typescript-eslint/no-explicit-any */
export enum NoteActivityType {
  UserEntered = 'UserEntered',

  // System generated
  StatusChange = 'StatusChange',
  ConfigurationChange = 'ConfigurationChange',
}

export interface InterpolatedMessageModel {
  m: string; // The translation key - in the "backend" namespace.
  a: any; // The arguments for the translation.
}

export interface AuthorModel {
  id: string; // User email
  dn: string; // User display name
  sys: boolean; // System user, ignore the display name
}

export interface NoteModel {
  id: string; // Note ID
  text: string | null; // Note text.
  createdAt: string; // Timestamp of note creation.
  createdBy: AuthorModel; // User who created the note.
  nt: NoteActivityType;
  im: InterpolatedMessageModel | null; // Interpolated message for the note.
}

export interface PostNoteModel {
  text: string;
}

export interface PostNoteQuery extends PostNoteModel {
  id: string;
}

export interface NameIdBasicModel {
  id: number;
  n: string; // Name
}
